/*
 * -----------------------------------------------------------------------
 *  <copyright file="grid-header/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';

import './styles.scss';
import { GridHeaderProps } from './grid-header.interface';
import { useTranslation } from '@hooks/index';

const GridHeader = ({
    title,
    menu,
    pager,
    totalRecords,
    showDeletedItems,
    showCustomTitle,
    subHeader,
    itemsName,
}: GridHeaderProps) => {
    const { t } = useTranslation();

    const gridTitle = showCustomTitle
        ? title
        : showDeletedItems
        ? `${title ? `${title} - ` : ''}${t(showDeletedItems.value ? 'all' : 'active')}`
        : title || '';

    return (
        <>
            <div className="grid-header" data-testid="grid-header">
                <div className="grid-header__title">{gridTitle}</div>
                <div className="grid-header__nav">
                    {pager}
                    <div className="grid-header__item grid-header__item--records">
                        <span className="records-title">
                            {totalRecords} {itemsName || t('common:Records')}
                        </span>
                    </div>
                    {menu}
                </div>
            </div>
            {subHeader}
        </>
    );
};

export default GridHeader;
